import React from "react";
import PartnerSection from "@modules/study/common/sections/partner/partner";
import UniPageBookingSection from "@modules/study/unipages/section_booking";

import {
  UniPageAnalyticsHero,
  UniPageAnalyticsMetrics,
  UniPageAnalyticsGetDetails,
  UniPageAnalyticsAdministration,
  UniPageAnalyticsInsights,
  UniPageAnalyticsAssistance,
  UniPageAnalyticsGetResult,
  UniPageAnalyticsFeatures,
} from "@modules/study/unipages/analytics";
import { LayoutUniversityPage } from "@unisearch/theme/layout";

const DataAnalytics = () => {
  return (
    <LayoutUniversityPage
      title="International Student Recruitment Strategy | UniSearch for University Data Analytics"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university/features`}
    >
      <UniPageAnalyticsHero />
      <UniPageAnalyticsFeatures />

      {/* <UniPageAnalyticsMetrics />
      <UniPageAnalyticsGetDetails />
      <UniPageAnalyticsAdministration />
      <UniPageAnalyticsInsights />
      <UniPageAnalyticsAssistance />
      <UniPageAnalyticsGetResult />
      <PartnerSection /> */}

      <UniPageBookingSection />
    </LayoutUniversityPage>
  );
};

export default DataAnalytics;
